// Pure helpers for the senior "Buy All" upsell — an add-on that cannot stand
// alone in the cart. Scoped per-student: a cart can hold multiple seniors
// (family / twins), so one student's upsell must attach to THAT student's base
// package, never another's. Kept out of the component so they're unit-testable.

export const optionOf = (op) => (op && op.option ? op.option() : undefined);

export const isSeniorBuyAllUpsell = (op) => !!optionOf(op)?.seniorBuyAllPromo;

export const isYearbookLine = (op) => /yearbook pose/i.test(optionOf(op)?.name || '');

// A real base package: not the buy-all upsell and not the free yearbook-pose line.
export const isBasePackage = (op) => !isSeniorBuyAllUpsell(op) && !isYearbookLine(op);

// True when deleting `target` would leave a senior "Buy All" upsell for the SAME
// student with no other base package — i.e. we should confirm before deleting.
export const wouldStrandUpsell = (orderPackages, target) => {
  if (!target || !isBasePackage(target)) return false;
  const sid = String(target.studentId);
  const sameStudent = (op) => String(op.studentId) === sid;

  const hasUpsell = orderPackages.some((op) => isSeniorBuyAllUpsell(op) && sameStudent(op));
  const anotherBase = orderPackages.some(
    (op) => String(op.id) !== String(target.id) && isBasePackage(op) && sameStudent(op),
  );
  return hasUpsell && !anotherBase;
};

// IDs of the upsells to drop locally after `deletedStudentId`'s base package was
// removed — mirrors the server prune. Only that student's upsells, and only when
// they have no base package left in the cart.
export const orphanedUpsellIds = (orderPackages, deletedStudentId) => {
  const sid = String(deletedStudentId);
  const stillHasBase = orderPackages.some((op) => isBasePackage(op) && String(op.studentId) === sid);
  if (stillHasBase) return [];

  return orderPackages
    .filter((op) => isSeniorBuyAllUpsell(op) && String(op.studentId) === sid)
    .map((op) => op.id);
};
